import { http } from '@/services';

export default {
  enviar: (contato) => {
    
    return http.post('contato/', contato)
  }
}